// extracted by mini-css-extract-plugin
module.exports = {"newsfeed":"fe-z"};